/**
 * Part of ChooseVehicle Non-DDC flow
 * Allows User to Search OR Build Vehicle in the Active Deal
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ChangeVehicleActivity } from '@makemydeal/dr-activities-change-vehicle';
import { CDL_V3_EVENT } from '@makemydeal/dr-shared-types';
import { SCI_CDL_TAGS } from '@makemydeal/dr-sales-checkin-types';
import { useChangeVehicle } from '../../hooks/useChangeVehicle';
import { useShowroomLoadingIndicatorDisappearsTelemetry } from '../../hooks/useShowroomLoadingIndicatorDisappearsTelemetry';
import { ChangeVehicleComponentContainer } from './ChangeVehicleComponent.style';

const ChangeVehicleComponent: React.FC = () => {
    const dispatch = useDispatch();
    const { isReady } = useChangeVehicle();
    useShowroomLoadingIndicatorDisappearsTelemetry('SC:InventoryLoadingIndicatorDisappears', isReady);

    // dc-sci-074: Browse Inventory Workflow Display — fires once the section finishes loading.
    useEffect(() => {
        if (isReady) {
            dispatch({ type: CDL_V3_EVENT, payload: SCI_CDL_TAGS['dc-sci-074']() });
        }
    }, [isReady, dispatch]);

    if (!isReady) {
        return <></>;
    }

    return (
        <ChangeVehicleComponentContainer data-testid="choose-vehicle-container">
            <ChangeVehicleActivity enableConfirmModal={false} />
        </ChangeVehicleComponentContainer>
    );
};

export default ChangeVehicleComponent;
